import { ScenarioTypeEnum, StatusEnum } from "../pages/scenario-form/types";
import { ColumnField } from "../pages/scenarios/useScenariosPageColumns";

export const updateColumnVisibility = (
  currentColumns: ColumnField[],
  column: ColumnField,
  isVisible: boolean
): ColumnField[] => {
  if (isVisible && !currentColumns.includes(column)) {
    return [...currentColumns, column];
  }
  if (!isVisible) {
    return currentColumns.filter((c) => c !== column);
  }
  return currentColumns;
};

export const updateStatusFilter = (
  currentFilters: StatusEnum[],
  value: StatusEnum,
  checked: boolean
): StatusEnum[] => {
  if (checked) {
    return [...currentFilters, value];
  }
  return currentFilters.filter((item) => item !== value);
};

export const updateTypeFilter = (
  currentFilters: ScenarioTypeEnum[],
  value: ScenarioTypeEnum,
  checked: boolean
): ScenarioTypeEnum[] => {
  if (checked) {
    return [...currentFilters, value];
  }
  return currentFilters.filter((item) => item !== value);
};
